import { render, staticRenderFns } from "./doctoral-cymposium.vue?vue&type=template&id=f1b07a6a&scoped=true&"
import script from "./doctoral-cymposium.vue?vue&type=script&lang=js&"
export * from "./doctoral-cymposium.vue?vue&type=script&lang=js&"
import style0 from "./doctoral-cymposium.vue?vue&type=style&index=0&id=f1b07a6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b07a6a",
  null
  
)

export default component.exports